<script lang="ts">
    import CN from "classnames";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Icon from "@components/Icon.svelte";
    import T from "@components/T.svelte";

    import SaveIcon from "./icons/SaveIcon.svelte";

    let className = "";
    export { className as class };
    export let namespace: string;
</script>

<BaseButton class={CN("gw-wl-save-button", className)} on:click>
    <div class="gw-wl-save-button__refraction" />
    <Icon class="gw-wl-save-button__icon" width="16px" height="16px">
        <SaveIcon />
    </Icon>
    <span class="gw-wl-save-button__text">
        <T {namespace} translationKey="save_wishlist_button_text" />
    </span>
</BaseButton>

<style lang="postcss" global>
    .gw-wl-save-button {
        display: flex;
        width: fit-content;
        align-items: center;
        position: relative;
        overflow: hidden;
    }

    .gw-wl-save-button__icon path {
        color: var(--gw-wl-wishlistDrawerAndPageSettings-linkColor);
    }

    .gw-wl-save-button__text {
        color: var(--gw-wl-wishlistDrawerAndPageSettings-linkColor);
        font-weight: 600;
        font-size: 12px;
        margin: 0 0 0 0.25em;
    }

    .gw-wl-save-button__refraction {
        position: absolute;
        width: 20px;
        height: 100%;
        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.3) 18.23%,
            rgba(255, 255, 255, 0.5) 36.46%,
            rgba(255, 255, 255, 0.5) 56.77%,
            rgba(255, 255, 255, 0.3) 79.69%,
            rgba(255, 255, 255, 0) 100%
        );
        transform: rotate(340deg);
        animation: refractionAnimation 2s cubic-bezier(0.02, 0.02, 0.15, 1.35)
            infinite;
        opacity: 0;
        pointer-events: none;
    }

    .gw-wl-save-button:hover .gw-wl-save-button__refraction,
    .gw-wl-save-button:focus .gw-wl-save-button__refraction {
        opacity: 1;
    }

    @keyframes refractionAnimation {
        0% {
            left: -20px;
        }
        100% {
            left: 100%;
        }
    }
</style>
